/**
 * Maps application identifiers to the rights required to access them
 * Add new applications and their required rights here
 */

// Application permission types
export interface ApplicationPermission {
  appId: string;
  /** Function to check if user has permission */
  checkPermission: (rightUserUtil: any, workspaceId: string) => boolean;
}

export const APPLICATION_PERMISSIONS: Record<string, ApplicationPermission> = {
  devicemanager: {
    appId: 'devicemanager',
    checkPermission: (rightUserUtil, _workspaceId) => {
      // All authorized users can access devicemanager
      return rightUserUtil.isAuthorizedUser();
    },
  },
  invitations: {
    appId: 'invitations',
    checkPermission: (rightUserUtil, workspaceId) => {
      // Check if user has SEE_INVITATIONS right for the workspace
      return rightUserUtil.canSeeInvitationsPage(workspaceId);
    },
  },
};

/**
 * Helper function to check if user has permission for a specific app
 */
export function hasPermissionForApp(
  appId: string,
  rightUserUtil: any,
  workspaceId: string
): boolean {
  const appPermission = APPLICATION_PERMISSIONS[appId];

  // If no permission config, default to requiring authorized user
  if (!appPermission) {
    return rightUserUtil.isAuthorizedUser();
  }

  return appPermission.checkPermission(rightUserUtil, workspaceId);
}
